import { AppBar, IconButton, Menu, MenuItem, Toolbar, Typography } from "@material-ui/core";
import { useState, useCallback } from "react";
import { DefaultProfile, PriceLOCQWhiteLogo } from "../../../images";
import Image from "../image/image";
import styles from "./header.module.scss";
import KeyboardArrowDownRoundedIcon from "@material-ui/icons/KeyboardArrowDownRounded";
import { useApi } from "hooks";
import { redirectTo } from "utils";
import { logout } from "apis";
import { Path } from "enums";
import { useContext } from "react";
import { AppContext, MessagesContext } from "contexts";
import IconNotificationCount from "../icon-notification-count/icon-notification-count";
import { EmailOutlined, GetAppRounded } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import locale from "localization";

const Header = ({ title, setNewNotification, newNotification }) => {
  const [open, setOpen] = useState(false);
  const { toggleLoading } = useContext(AppContext);
  const messages = useContext(MessagesContext);
  const history = useHistory();
  const { request: logoutRequest } = useApi({
    api: logout,
  });

  const logoutCb = useCallback(async () => {
    toggleLoading(true);
    await logoutRequest();
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("stationId");
    localStorage.removeItem("role");
    toggleLoading(false);
    redirectTo(Path.Auth);
  }, [logoutRequest, toggleLoading]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <div id="header">
      <AppBar className={styles.headerContainer}>
        <Toolbar disableGutters>
          <div className={styles.logoContainer}>
            <Image src={PriceLOCQWhiteLogo} className={styles.logo} />
          </div>
          <div className={styles.toolbarContainer}>
            <Typography variant="h6" className={styles.title}>
              {title}
            </Typography>
            <div className={styles.menuContainer}>
              <IconButton aria-controls="menu-appbar" aria-haspopup="true" onClick={() => {
                setNewNotification();
                history.push(Path.Download);
              }}>
                {
                  newNotification &&
                  <div className={styles?.notificationIcon}/>
                }
                <GetAppRounded className={styles.downloadIcon} />
              </IconButton>
              {messages && (
                <IconNotificationCount
                  icon={EmailOutlined}
                  count={messages.unreadMessages}
                  onClick={() => {
                    history.push(Path.Inbox);
                  }}
                />
              )}

              <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpen}
              >
                <Image src={DefaultProfile} className={styles.profile} />
                <KeyboardArrowDownRoundedIcon className={styles.caretIcon} />
              </IconButton>
              <Menu
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                keepMounted
                open={open}
                className={styles.menu}
                onClose={handleClose}
              >
                <MenuItem className={styles.menuItem} onClick={logoutCb}>
                  {locale.logout}
                </MenuItem>
              </Menu>
            </div>
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default Header;
